<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :orderbutton="true" :listStatus="listStatus" :headers="filter_headers" :viewName="viewName" :orderSummary="orderSummary" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-widget title="Thống kê chi phí" v-if="selectedOrders.length > 0">
              <div slot="widget-content">
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Số đơn hàng:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.length}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Tổng cân:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.OrderWeight).reduce((prev, curr) => prev + curr, 0) | currency('',2)}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Tổng tiền:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Đã cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Cần cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.MinDeposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Còn thiếu:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{(selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) - selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0)) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0 pl-4>
                        <a href="javascript:void(0)" @click="depositDialog">Cập nhật đơn hàng</a>
                    </v-flex>
                  </v-layout>
              </div>
          </v-widget>
          <v-data-table
            :headers="headers"
            :items="orders"
            :must-sort="true"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :loading="loading"
            show-select
            :mobile-breakpoint="100"
            v-model="selectedOrders"
            item-key="ID"
            class="elevation-1"
          >
            <template v-slot:item="{ item, isSelected, select}">
              <tr :active="isSelected">
                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                <td><a target="_blank" :href="'/don-hang/' + item.ID">{{ 'MD'+item.ID }}</a></td>
                <td>
                  <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                </td>
                <td>
                  <v-img :src="item.image_origin && item.image_origin.includes('firebase') ? item.image_origin : decodeURIComponent(item.image_origin)" width="64px" height="64px"></v-img>
                </td>
                <td>{{ item.TransactionCode }}</td>
                <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                <td class="text-end font-weight-bold">{{ item.MinDeposit | currency}}</td>
                <td>{{ item.UID }}</td>
                <td v-if="orderRole & 1">
                  <a target="_blank" :href="'khach-hang/quan-ly-khach-hang/' + item.UID">{{ item.CustomerName }}</a>
                </td>
                <td v-else>
                  {{ item.CustomerName }}
                </td>
                <td v-if="orderRole & 512">
                  <v-edit-dialog
                    :return-value.sync="item.BuyerName"
                    large
                    lazy
                    persistent
                    @save="saveStaff(item.ID, item.BuyerID, item.CSID)"
                  >
                    <div>{{ item.BuyerName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="p_staffs"
                        v-model="item.BuyerID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.BuyerName = getStaffName(item.BuyerID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!(orderRole & 512)">
                  {{ item.BuyerName }}
                </td>
                <td v-if="(orderRole & 1024)">
                  <v-edit-dialog
                    :return-value.sync="item.CSName"
                    large
                    lazy
                    persistent
                    @save="saveStaff(item.ID, item.BuyerID, item.CSID)"
                  >
                    <div>{{ item.CSName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="cs_staffs"
                        v-model="item.CSID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.CSName = getStaffName(item.CSID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!(orderRole & 1024)">
                  {{ item.CSName }}
                </td>
                <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFragileGoods" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.GuaranteeType ? 'Bảo hiểm' : '' }}
                </td>
                <td>
                  {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.CreatedDate | display_date('HH:mm:ss')}}
                </td>
                <td>
                  {{ item.BoughtDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.BoughtDate | display_date('HH:mm:ss')}}
                </td>
                <!-- <td>
                  {{ item.SignalDatePackage | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.SignalDatePackage | display_date('HH:mm:ss')}}
                </td> -->
                <td>
                  {{ item.ShopDeliverDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.ShopDeliverDate | display_date('HH:mm:ss')}}
                </td>
                <td>
                  {{ item.StoreCNExDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.StoreCNExDate | display_date('HH:mm:ss')}}
                </td>
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon medium @click="gotoDetail(item.ID)" v-on="on">fa-external-link-alt</v-icon>
                      </template>
                      <span>Chi tiết đơn hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogExport" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Xuất file</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <div>Ngày tạo đơn</div>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Từ ngày" v-model="export_options.start_date" :rules="date_validation"></v-text-field>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Đến ngày" v-model="export_options.end_date" :rules="date_validation"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogExport = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="exportFile">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.Products" :key="item.ID">
                    <v-list-item-content>
                      <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <!-- <v-text-field label="Link ảnh" v-model="item.Image"></v-text-field> -->
                      <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="`${getImages(index)}`" ref="imageFile"/>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-text-field label="Thuộc tính" v-model="item.Property"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="item.Price"></h-currency-input>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                    </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.Products.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link ảnh" v-model="newProduct.Image"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                        <div class="row">
                            <div class="col-md-4">
                                <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image" ref="imageFile"/>
                            </div>
                            <div class="col-md-8">
                                <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                                <button @click="chooseImage(newProduct)" style="cursor: point">Tải ảnh</button>
                            </div>
                        </div>
                    </div>
                  </v-flex>
                  <v-flex lg3 md3 sm12>
                    <v-text-field label="Thuộc tính" v-model="newProduct.Property"></v-text-field>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="newProduct.Price"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-file :dialogUpload="dialogImport" title="Import đơn hàng" temp_file="don_hang_mau.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    <v-dialog v-model="dialogDeposit" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Cập nhật đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-select v-model="selectedActionType" :items="bulkActionType" item-value="value" item-text="name"></v-select>
              </v-flex>
              <v-flex lg12>
                <!-- <h-currency-input v-if="selectedActionType == 1" label="Tổng tiền cọc (₫)" v-model="actionValueNumber" :decimal="0"></h-currency-input> -->
                <h-currency-input v-if="selectedActionType == 2" label="Tỷ giá tệ" v-model="actionValueNumber" :decimal="0"></h-currency-input>
                <!-- <h-currency-input v-if="selectedActionType == 3" label="Lãi tỷ giá" v-model="actionValueNumber" :decimal="0"></h-currency-input> -->
                <h-currency-input v-if="selectedActionType == 4" label="Tỷ lệ cọc (%)" v-model="actionValueNumber" :decimal="0"></h-currency-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogDeposit = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="depositBlance">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VWidget from "@/components/VWidget";
import upload_file from "@/components/popups/upload_file";
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, makeid } from "@/commons/utils";
import firebase from 'firebase';
import moment from "moment";
export default {
  components: {
    VWidget,
    "hpo-filter": Filtering,
    "upload-file": upload_file,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      dialogDeposit: false,
      imageData: null,
      hideImage: false,
      search: "",
      selectedOrders: [],
      selectedActionType: 1,
      bulkActionType: [
        {value: 1, name: 'Chờ đặt cọc'},
        {value: 2, name: 'Tỷ giá'},
        // {value: 3, name: 'Lãi tỷ giá'},
        {value: 4, name: 'Tỷ lệ cọc'}
      ],
      headers: [       
        {
          text: "ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.ORDER_STATUS
        },
        {
          text: "Ảnh SP",
          value: "image_origin",
          sortable: false,
          filterable: false,
          dataType: dataType["String"]
        },
        {
          text: "MVĐ",
          value: "TransactionCode",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cần cọc",
          value: "MinDeposit",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "ID khách",
          value: "UID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khách hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Nhân viên đặt hàng",
          value: "BuyerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Nhân viên hỗ trợ",
          value: "CSName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Lưu ý đặc biệt",
          sortable: false,
          filterable: false,
        },
        {
          text: "Ngày lên đơn",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày mua hàng",
          value: "BoughtDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        // {
        //   text: "Ký nhận",
        //   value: "SignalDatePackage",
        //   filterable: true,
        //   sortable: true,
        //   dataType: dataType["Date"]
        // },
        {
          text: "Phát hàng",
          value: "ShopDeliverDate",
          filterable: true,
          sortable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Xuất kho TQ",
          value: "StoreCNExDate",
          filterable: true,
          sortable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Thao tác",
          align: "center",
        }
      ],
      pagination: {
          ...configs.PAGINATION,
          sortBy: ["ID"]
      },
      selectedTab: 0,
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      listStatus: configs.ORDER_STATUS,
      viewName: "order_list",
      filterConditions: [],
      quickFilterConditions: [],
      dialogExport: false,
      totalDeposit: 0,
      dialogNew: false,
      dialogImport: false,
      newProduct: {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      },
      newOrder: {
        UID: 0,
        Products: []
      },
      export_options: {
        start_date: moment.utc(Date.now()).subtract(1, 'days').format(configs.SHORT_DATE_FORMAT),
        end_date: moment.utc(Date.now()).format(configs.SHORT_DATE_FORMAT)
      },
      date_validation: [v => v.match(/^(0?[1-9]|[12][0-9]|3[01])[\-](0?[1-9]|1[012])[\-]\d{4}$/) || "DD-MM-YYYY"]
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    orders: function(val) {
      this.selectedOrders = [];
    }
  },
  computed: {
    ...mapState({
      orders: state => state.main_order.all.data,
      orderSummary: state => state.main_order.all.summary,
      total_rows: state => state.main_order.all.total,
      loading: state => state.main_order.loading,
      staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
        }),
      p_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        }),
      cs_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        }),
      customers: state => state.customer.master.data,
      guarantees: state => {
          let tmp = [{name: 'Không sử dụng', value: 0}];
          if(state.feeGuarantee.all.data) {
          state.feeGuarantee.all.data.forEach(element => {
              tmp.push({name: element.PackageName, value: element.ID});
          });
          }
          return tmp;
      }
    }),
    pages() {
      return Math.ceil(
        this.total_rows / this.options.itemsPerPage
      );
    },
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Bảo hiểm",
          value: "GuaranteeType",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      return tmp;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    orderRole() {
      return this.$store.state.authentication.role.Orders;
    },
    customerId() {
      return this.$route.query.uid && this.$route.query.uid != '' ? Number(this.$route.query.uid) : 0;
    },
    selectedStatus() {
      return this.$route.query.status && this.$route.query.status != '' ? Number(this.$route.query.status) : 0;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      if(this.customerId > 0) {
        param.filter.push({
          column: "UID",
          value: this.customerId,
          condition: "equal",
        });
        param.uid = this.customerId;
      }
      if(this.selectedStatus > 0) {
        param.filter.push({
          column: "Status",
          value: this.selectedStatus,
          condition: "equal",
        });
      }
      this.$store.dispatch("main_order/getListOrders", param);
      this.$store.dispatch("feeGuarantee/getList");
      this.getCustomerList();
    },
    gotoDetail: function(id) {
      let routeData = this.$router.resolve({
        name: "OrderDetail",
        params: {
          Pid: id,
          title: `Chi tiết đơn hàng (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    saveStaff(orderId, buyerId, csId) {
      const updateInfo = {
        OrderID: orderId,
        CustomerServiceID: csId,
        BuyerID: buyerId
      };
      this.$store.dispatch("main_order/updateOrderDetail", updateInfo);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    },
    exportDialog() {
      this.dialogExport = true;
    },
    exportFile() {
      let param = {filter: this.filterConditions, quickFilter: this.quickFilterConditions};
      if(this.customerId > 0) {
        param.filter.push({
          column: "UID",
          value: this.customerId,
          condition: "equal",
        });
        param.uid = this.customerId;
      }
      this.$store.dispatch("main_order/export_order", param);
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "BuyerID", "CustomerServiceID", "ReceivePlaceID"]
      });
    },
    appendProduct() {
      this.newOrder.Products.push(this.newProduct);
      this.newProduct = {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      }
    },
    createData() {
      this.dialogNew = true;
    },
    createNewOrder() {
      if(this.newOrder.Products.length == 0) {
        sendErrorNotice("Hãy nhập danh sách sản phẩm!");
        return;
      }
      if(this.newOrder.UID == 0) {
        sendErrorNotice("Hãy chọn khách hàng!");
        return;
      }
      const cust = _.find(this.customers, {'ID': this.newOrder.UID});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.newOrder.Username = cust.Username;
      this.newOrder.BuyerID = cust.BuyerID;
      this.newOrder.CustomerServiceID = cust.CustomerServiceID;
      this.newOrder.ReceivePlaceID = cust.ReceivePlaceID;

      this.$store.dispatch("main_order/createNew", {'data': this.newOrder, 'param': param});
      this.newOrder = {
        UID: 0,
        Products: []
      };
      this.dialogNew = false;
      sendSuccessNotice('Tạo mới đơn hàng thành công.');
    },
    chooseImage(item) {
        this.newProduct.Image = '';
        this.$refs.fileInput.click();
    },
    previewImage(event) {
        this.imageData = event.target.files[0];
        this.$refs.fileInput.value = null;
        this.onUpload()
    },
    onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                
            },
            error => {
              sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
            },
            () => {
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.newProduct.Image =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    },
    getImages(index) {
        return this.newOrder.Products[index].Image;
    },
    importFileDialog() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
          const formData = new FormData();
          formData.append('excel_file', f);
          formData.append('filename', f.name);
          this.$store.dispatch("main_order/import_order", formData);
      }
      this.dialogImport = false;
    },
    depositDialog() {
      if(!this.adminRole && !this.paymentRole) {
        sendErrorNotice("Bạn không có quyền thực hiện chức năng này!");
        return;
      }
      if(this.selectedOrders.length == 0) {
        sendErrorNotice("Hãy chọn các đơn muốn cập nhật!");
        return;
      }
      this.dialogDeposit = true;
    },
    depositBlance() {
      if(this.selectedActionType == 2 && this.actionValueNumber <= 0) {
        sendErrorNotice("Hãy nhập tỷ giá tệ!");
        return;
      }
      if(this.selectedActionType == 4 && this.actionValueNumber <= 0) {
        sendErrorNotice("Hãy nhập tỷ lệ cọc!");
        return;
      }

      if(this.selectedActionType == 1) {
        var needDepositOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia; });
        var ids = _.map(needDepositOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          Status: configs.ORDER_STATUS_ENUM.cho_dat_coc
        });
      }
      else if(this.selectedActionType == 2) {
        var needUpdateOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || item.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia; });
        var ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          ExchangeRate: this.actionValueNumber,
          ReCal: true
        });
      }
      else if(this.selectedActionType == 3) {
        var needUpdateOrder = _.filter(this.selectedOrders, (item) => { return item.Status != configs.ORDER_STATUS_ENUM.hoan_thanh; });
        var ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          ExchangeRevenue: this.actionValueNumber
        });
      }
      else if(this.selectedActionType == 4) {
        var needUpdateOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || item.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia; });
        var ids = _.map(needUpdateOrder, 'ID');
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          MinDepositRate: this.actionValueNumber
        });
      }
      
      this.dialogDeposit = false;
    },
  },
  created() {
    this.$store.dispatch("commons/getAllUsers");
  },
  mounted() {
    this.filterConditions = [];
    this.quickFilterConditions = [];
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_SAVE_DATA", this.exportFile);
    this.$root.$on("REQUEST_OTHER_ACTION", this.importFileDialog);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_SAVE_DATA", this.exportFile);
    this.$root.$off("REQUEST_OTHER_ACTION", this.importFileDialog);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
<style lang="stylus" scoped>
.image-product {
  width: 64px;
  height: 64px;
}
</style>